export const tooltipText = {
  campaignSource: '表示為您帶來流量網站或管道。<br />例：utm_source=google, utm_source=facebook',
  campaignMedium:
    '表示行銷或廣告的媒介類型，如：單次點擊出價CPC、聯播網廣告。<br />例：utm_medium=cpc, utm_medium=banner',
  campaignName: '辨別廣告活動或行銷專案的名稱或形式。<br />例：utm_campaign=spring_sale',
  campaignTerm: '辨別付費關鍵字的廣告字詞<br />如： utm_term=baby_sling',
  campaignContent:
    '辨識A/B測試的廣告內容，表示連到同一網址的不同廣告或連結。<br />如：utm_content=bannerlink, utm_content=textlink',
  chineseTag: '客製化網址後綴字串，可使用中、英、數字，不可包含空格',
  nonEditableChineseTag: '總點擊數 >10，不可編輯。例：https://wenk.in/3c0a2b3/中文標記',
  imageRecommendation: '圖片最佳比例 1200x628px (jpg 或 png)，不得大於1MB',
  utmParamsContent: '若網址中有重複 UTM，GA只會紀錄最後一個 UTM 參數',
  conversionUnlockContent: '開通 GA4 Reports 模組，解鎖「轉換數」功能'
}
